import createAxiosInstance from '../createAxiosInstance'

const mapiPath = process.env.VUE_APP_MAPI_URL
const mapiInstance = createAxiosInstance(mapiPath)

export const apiOrderFood = {
  // 儲值1 回補2 作廢3 這裡只用得到作廢
  getVoidNoteTemplates: () => mapiInstance.get('/ServicePointNoteTemplate?TypeId=3'),
  // 取得拒單範本
  getRejectNoteTemplates: () => mapiInstance.get('/ServicePointNoteTemplate?TypeId=4'),
  getSystemUserList: () => mapiInstance.get('/Community/FeatureStaffs?FeatureId=8') // 8為點餐的權限Id
}
